define.alias("shared/components/shared/card", "calendar/components/shared/card");